import { request as queryRequest } from './reducers/query';
import { request as updateRequest } from './reducers/update';

// eslint-disable-next-line import/no-default-export
export default {
    FRAUD_AND_COMPLIANCE_QUERY_REQUEST: queryRequest,
    FRAUD_AND_COMPLIANCE_UPDATE_REQUEST: updateRequest,
};
